import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';

interface User {
  email: string;
  name: string;
}

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  const checkUserStatus = () => {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        const userData = JSON.parse(userStr);
        setUser(userData);
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('user');
        setUser(null);
      }
    } else {
      setUser(null);
    }
  };

  useEffect(() => {
    // 初始检查用户登录状态
    checkUserStatus();

    // 监听localStorage变化
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'user') {
        checkUserStatus();
      }
    };

    // 监听自定义事件（用于同一页面内的状态更新）
    const handleUserChange = () => {
      checkUserStatus();
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('userStatusChanged', handleUserChange);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('userStatusChanged', handleUserChange);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('user_token');
    setUser(null);
    // 触发自定义事件通知其他组件
    window.dispatchEvent(new Event('userStatusChanged'));
    navigate('/');
  };

  return (
    <header className="bg-white text-gray-900 sticky top-0 z-50 shadow-lg">
      <div className="container mx-auto px-4">
        <div className="flex justify-between items-center py-4">
          {/* Logo */}
          <Link to="/" className="text-2xl font-bold text-gray-900 hover:text-orange-500 transition-colors">
            <div className="flex items-center space-x-2">
              <div className="w-10 h-10 bg-orange-500 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">S</span>
              </div>
              <span>力量举工作室</span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link 
              to="/" 
              className="hover:text-orange-500 transition-colors font-medium"
            >
              首页
            </Link>
            <Link 
              to="/plan" 
              className="hover:text-orange-500 transition-colors font-medium"
            >
              计划
            </Link>
            <Link 
              to="/help" 
              className="hover:text-orange-500 transition-colors font-medium"
            >
              帮助
            </Link>
          </nav>

          {/* User Actions */}
          <div className="hidden md:flex items-center space-x-4">
            {user ? (
              <div className="flex items-center space-x-4">
                <Link
                  to="/profile"
                  className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
                >
                  个人主页
                </Link>
                <span className="text-gray-700">欢迎，{user.name}</span>
            <button
                  onClick={handleLogout}
                  className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
            >
                  登出
            </button>
              </div>
            ) : (
              <Link
                to="/login"
                className="text-gray-700 hover:text-orange-500 transition-colors font-medium"
              >
                登录
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={toggleMenu}
            className="md:hidden text-gray-900 hover:text-orange-500 transition-colors"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {isMenuOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden pb-4 border-t border-gray-200">
            <nav className="flex flex-col space-y-4 pt-4">
              <Link 
                to="/" 
                className="hover:text-orange-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                首页
              </Link>
              <Link 
                to="/plan" 
                className="hover:text-orange-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                计划
              </Link>
              <Link 
                to="/help" 
                className="hover:text-orange-500 transition-colors font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                帮助
              </Link>
              <div className="pt-4 border-t border-gray-200">
                {user ? (
                  <div className="space-y-2">
                    <Link
                      to="/profile"
                      className="block text-gray-700 hover:text-orange-500 transition-colors font-medium"
                      onClick={() => setIsMenuOpen(false)}
                    >
                      个人主页
                    </Link>
                    <div className="text-gray-700">欢迎，{user.name}</div>
              <button
                onClick={() => {
                        handleLogout();
                  setIsMenuOpen(false);
                }}
                      className="block text-gray-700 hover:text-orange-500 transition-colors font-medium"
              >
                      登出
              </button>
                  </div>
                ) : (
                  <Link
                    to="/login"
                    className="block text-gray-700 hover:text-orange-500 transition-colors font-medium"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    登录
                  </Link>
                )}
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header; 